import queryString from 'query-string';
import http from '../httpConfig';
import { List } from '../interfaces/role.interface';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { buildPagingResponse } from '../utils/methods';

const list = (payload: List) => {
  // Mock data
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        records: [
          { id: 1, name: 'Admin', code: 'admin' },
          { id: 2, name: 'Manager', code: 'manager' },
          { id: 3, name: 'User', code: 'user' },
        ],
        total: 3,
        page: payload.page || 1,
        perPage: payload.perPage || 10,
      });
    }, 500);
  });

  // const { searchText, ...others } = payload;
  // const paging = buildPagingResponse(others);
  // const url = `${API_ENDPOINTS.listRoles}?${queryString.stringify(paging)}`;
  // return http.post(url, { search: searchText });
};

const lookup = (payload: any) => {
  const url = `${API_ENDPOINTS.lookupRoles}?${queryString.stringify({ search: payload.search })}`;
  return http.get(url);
};

const RoleService = {
  list,
  lookup,
};

export default RoleService;
